export function getCookieMap(cookie) {
  return cookie.split(';').reduce((a, b) => {
    const [key, val] = b.split('=');
    a[key.trim()] = val;
    return a;
  }, {});
}
export function getAuthTokenFromCookie(cookie) {
  if (cookie) {
    const cookieMap = getCookieMap(cookie);
    return cookieMap.AuthToken || null;
  }

  return null;
}
export function clearCookie(authDomain) {
  document.cookie = "AuthToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; ".concat(authDomain ? "domain=".concat(authDomain) : '');
}